import { useTheme } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { numberComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import { formatDurationInSeconds } from "@entrilia/shared/utilities/formatters";
import { convertToNumber } from "@entrilia/shared/utilities/numberHelper";

interface Props {
  pageViews: Record<number, number>;
  totalDurationOfVideoFile?: number;
}

const PageViewsChart = ({ pageViews, totalDurationOfVideoFile }: Props) => {
  const theme = useTheme();
  const sortedPageViews = Object.entries(pageViews).sort(numberComparerBy(([key]) => parseInt(key, 10)));
  const xAxisData = sortedPageViews.map(([key]) => key);
  const seriesData = sortedPageViews.map(([, value]) => value);

  return (
    <BarChart
      series={[
        {
          label: "Time spent:",
          data: seriesData,
          valueFormatter: (value) => (value ? formatDurationInSeconds(value) : "None"),
        },
      ]}
      xAxis={[
        {
          id: "page_numbers",
          disableTicks: true,
          scaleType: "band",
          data: xAxisData,
          valueFormatter: (value: string, ctx) => {
            if (ctx.location === "tooltip") {
              return totalDurationOfVideoFile ? `Segment ${value}` : `Page ${value}`;
            }

            if (totalDurationOfVideoFile) {
              const segmentNumber = convertToNumber(value);
              const segmentsCount = Object.keys(pageViews).length;
              if (segmentNumber !== undefined) {
                const segmentLength = Math.round(totalDurationOfVideoFile / segmentsCount);
                const segmentStart = segmentLength * (segmentNumber - 1);
                const segmentEnd =
                  segmentNumber === segmentsCount ? Math.round(totalDurationOfVideoFile) : segmentStart + segmentLength;
                return `${formatDurationInSeconds(segmentStart)} - ${formatDurationInSeconds(segmentEnd)}`;
              }
            }

            return value;
          },
        },
      ]}
      yAxis={[
        {
          disableTicks: true,
          valueFormatter: (value: number | string) =>
            typeof value === "number" ? formatDurationInSeconds(value) : value,
          colorMap: {
            type: "piecewise",
            thresholds: [],
            colors: [theme.palette.primary.main],
          },
        },
      ]}
      grid={{ vertical: true, horizontal: true }}
      hideLegend
    />
  );
};

export default PageViewsChart;
